import { useEffect, useState } from 'react'
import { useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { FdeEditorDialog } from '@/frontend/features/Fde/FdeEditorSurface'
import { SelectControl, TextControl } from '@/frontend/features/Fde/FormControls'
import { fdeProjectPath, fdeRoutes } from '@/frontend/features/Fde/routes'
import type { FdeCopy } from '@/frontend/features/Fde/types'
import type { ProjectTeamPerson } from '@/frontend/features/Fde/projectTeamTypes'

interface Props {
  open: boolean; onOpenChange: (open: boolean) => void; projectId: string
  people: ProjectTeamPerson[]; copy: FdeCopy
}

export default function ProjectGuestDialog({ open, onOpenChange, projectId, people, copy }: Props) {
  const [external, setExternal] = useState(false)
  const form = useForm({ user_id: '', email: '', role_name: '' })
  useEffect(() => {
    if (!open) return
    form.reset(); form.clearErrors(); setExternal(people.length === 0)
  }, [open])

  function submit() {
    form.transform((data) => ({ project_member: {
      role_name: data.role_name, ...(external ? { email: data.email } : { user_id: data.user_id }),
    }, return_to: 'access' }))
    form.post(fdeProjectPath(fdeRoutes.projectMembers, projectId), { preserveScroll: true, onSuccess: () => onOpenChange(false) })
  }

  return <FdeEditorDialog open={open} onOpenChange={onOpenChange} title={copy.management.invite_guest_title} closeLabel={copy.common.close} size="standard" footer={<>
    <Button variant="outline" onClick={() => onOpenChange(false)}>{copy.common.cancel}</Button>
    <Button disabled={form.processing || !form.data.role_name.trim() || !(external ? form.data.email.trim() : form.data.user_id)} onClick={submit}>{external ? copy.management.team_invite : copy.common.add}</Button>
  </>}>
    <div className="space-y-4">
      {external ? <><p className="text-xs text-muted-foreground">{copy.management.invite_guest_description}</p><TextControl type="email" label={copy.management.invite_email} value={form.data.email} onChange={(event) => form.setData('email', event.target.value)} required /></>
        : <SelectControl label={copy.management.team_person} value={form.data.user_id} onChange={(value) => form.setData('user_id', value)} placeholder={copy.people.select_person} options={people.map((person) => ({ value: person.id, label: `${person.name} · ${person.email}` }))} />}
      <TextControl label={copy.people.project_role} value={form.data.role_name} onChange={(event) => form.setData('role_name', event.target.value)} placeholder={copy.people.project_role_placeholder} required />
      {(people.length > 0 || !external) && <button type="button" className="text-xs text-muted-foreground underline underline-offset-4 hover:text-foreground" onClick={() => setExternal(!external)}>{external ? copy.management.team_choose_existing : copy.management.team_invite_external}</button>}
    </div>
  </FdeEditorDialog>
}
